import { Options, merge } from 'highcharts';
import { baseChartOptions } from './base-chart.options';

/**
 * Configuration for Column Range chart type
 * Extends the base chart configuration
 * Requires the highcharts-more module
 */
export const columnrangeChartOptions: Options = merge({}, baseChartOptions, {
    chart: {
        type: 'columnrange'
    },
    plotOptions: {
        columnrange: {
            borderRadius: 2,
            borderWidth: 0,
            pointPadding: 0.1,
            groupPadding: 0.2,
            dataLabels: {
                enabled: false,
                format: '{y}'
            }
        }
    },
    tooltip: {
        crosshairs: true,
        shared: true,
        headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
        pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.low} - {point.high}</b><br/>'
    },
    // For range charts, we often want to show both axes
    yAxis: {
        title: {
            text: 'Range'
        }
    }
} as Options);